import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { NgxSelectModule } from 'ngx-select-ex';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FileChooserComponent } from './file-chooser.component';
import { FileChooserPresentationModule } from '../FileChooserPresentation/file-chooser-presentation.module';
import {SearchCriteriaModule} from '../project/searchFilter/search-criteria.module';
import {SharedRefreshService} from '../service/sharedRefreshService';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSelectModule,
    FileChooserPresentationModule,
    SearchCriteriaModule
  ],
  declarations: [FileChooserComponent],
  providers: [SharedRefreshService],
  exports: [FileChooserComponent]
})

export class FileChooserModule {

}
